var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3325_18512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 88C55.6695 88 66.8611 83.3643 75.1127 75.1127C83.3643 66.8611 88 55.6695 88 44C88 32.3305 83.3643 21.1389 75.1127 12.8873C66.8611 4.6357 55.6695 0 44 0C32.3305 0 21.1389 4.6357 12.8873 12.8873C4.6357 21.1389 0 32.3305 0 44C0 55.6695 4.6357 66.8611 12.8873 75.1127C21.1389 83.3643 32.3305 88 44 88ZM30.0781 30.0781C31.6937 28.4625 34.3062 28.4625 35.9047 30.0781L43.9828 38.1562L52.0609 30.0781C53.6766 28.4625 56.2891 28.4625 57.8875 30.0781C59.4859 31.6937 59.5031 34.3062 57.8875 35.9047L49.8094 43.9828L57.8875 52.0609C59.5031 53.6766 59.5031 56.2891 57.8875 57.8875C56.2719 59.4859 53.6594 59.5031 52.0609 57.8875L43.9828 49.8094L35.9047 57.8875C34.2891 59.5031 31.6766 59.5031 30.0781 57.8875C28.4797 56.2719 28.4625 53.6594 30.0781 52.0609L38.1562 43.9828L30.0781 35.9047C28.4625 34.2891 28.4625 31.6766 30.0781 30.0781Z",
    fill: "#AA182C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3325_18512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b423ac6d4d70b4c57066a536bc94f970.svg";
export { ForwardRef as ReactComponent };